import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ShortformItem2 = styled.div`
  position: relative;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;

  .video-wrap {
    display: block;
    width: 100%;
    height: ${mixin.pxToVw('590')};
    position: relative;

    .veVideo {
      position: absolute;
      inset: 0px;
      height: 100%;

      > div {
        height: inherit;
      }

      &.is-player-play {
        ~ .poster-img {
          opacity: 0;
          z-index: 0;
        }

        ~ .play-icon {
          display: none;
        }
      }
    }

    .poster-img {
      height: 100%;
    }

    .play-icon {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .loading-icon {
      display: none;
    }
  }

  .user-info {
    width: 100%;
    ${mixin.flex({ align: 'center', justify: 'flex-start' })};
    position: absolute;
    top: 0;
    left: 0;
    padding: 14px 14px 8px;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );

    .user-img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      margin-right: 8px;
    }

    .user-name {
      width: 206px;
      font-size: 15px;
      line-height: 130%;
      text-align: left;
    }
  }

  .shortform-info {
    ${mixin.flex({
      direction: 'column',
      justify: 'flex-end',
      align: 'flex-start',
    })};
    gap: 12px 0;
    height: 178px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.5) 100%
    );
    transform: translateZ(0);
    padding: 20px;
    text-align: left;

    .desc {
      font-size: 13px;
      line-height: 130%;
      word-break: break-all;
      overflow-wrap: anywhere;
    }

    .area-relatedPrd {
      width: 100%;
      ${mixin.flex({ align: 'flex-start', justify: 'flex-start' })};
      gap: 0 2px;

      .relatedprd-item {
        width: 62px;
        border-radius: 0;

        .img {
          width: 100%;
          padding-bottom: 133.87096774%;
          border-radius: 0;
        }

        .total .text {
          font-size: 12px;

          ~ .text {
            font-size: 10px;
            margin-top: 1px;
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20')};

    .video-wrap {
      .play-icon {
        top: ${mixin.pxToVw('12')};
        right: ${mixin.pxToVw('12')};
      }
    }

    .user-info {
      padding: ${mixin.pxToVw('14 14 8')};

      .user-img {
        width: ${mixin.pxToVw('28')};
        height: ${mixin.pxToVw('28')};
        margin-right: ${mixin.pxToVw('8')};
      }

      .user-name {
        width: ${mixin.pxToVw('206')};
        font-size: ${mixin.pxToVw('15')};
      }
    }

    .shortform-info {
      gap: ${mixin.pxToVw('12 0')};
      height: ${mixin.pxToVw('178')};
      padding: ${mixin.pxToVw('20')};

      .desc {
        font-size: ${mixin.pxToVw('13')};
      }

      .area-relatedPrd {
        gap: ${mixin.pxToVw('0 2')};

        .relatedprd-item {
          width: ${mixin.pxToVw('62')};

          .total .text {
            font-size: ${mixin.pxToVw('12')};

            ~ .text {
              font-size: ${mixin.pxToVw('10')};
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    border-radius: 24px;

    .video-wrap {
      height: 607px;
    }

    .user-info {
      padding: 16px 16px 14px;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.1) 70%
      );

      .user-img {
        width: 30px;
        height: 30px;
      }

      .user-name {
        font-size: 16px;
      }
    }

    .shortform-info {
      gap: 20px 0;
      height: 210px;
      padding: 30px;

      .desc {
        font-size: 15px;
      }

      .area-relatedPrd {
        gap: 0 2px;

        .relatedprd-item {
          .total .text {
            font-size: 14px;

            ~ .text {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
`;
